class ExtractSDKLLData extends HTMLElement {
  constructor () {
    super()

    this.state = {
      currentTier: null,
      pointsToNextTier: null,
      spendTillNextTier: null,
    }

    this.selectors = {
      lionTierProgressNextFirst:
        '[data-i18n-key="ui.dashboard.tiers.earn_amount_for_next_tier"]',
      lionTierProgressNext:
        '[data-i18n-key="ui.dashboard.tiers.earn_amount_for_next_tier_with_date"]',
      lionTierProgressCurrent:
        '[data-i18n-key="ui.dashboard.tiers.earn_amount_to_stay_in_tier_with_date"]',
    }
  }

  connectedCallback () {
    const observerConfig = {
      childList: true,
      subtree: true,
    }

    const observer = new MutationObserver(this.handleMutation.bind(this))
    observer.observe(this, observerConfig)
  }

  handleMutation (mutationsList, observer = null) {
    mutationsList.forEach(mutation => {
      if (
        mutation.type === 'childList' &&
        mutation.target.firstChild.id === 'loyaltylion'
      ) {
        let pointsToNextTier = this.querySelector(this.selectors.lionTierProgressNext)
        if (!pointsToNextTier) {
          pointsToNextTier = this.querySelector(this.selectors.lionTierProgressNextFirst)
        }
        if (!pointsToNextTier) return
        const pointsToNextTierValue = pointsToNextTier.querySelector('strong').textContent
        this.pointsToNextTier = Number(pointsToNextTierValue.replace(/,/g, ''))
        const formattedSpend = new Intl.NumberFormat(
          `${window.Shopify.locale}-${window.Shopify.country}`,
          { style: 'currency', currency: window.Shopify.currency.active, minimumFractionDigits: 0, maximumFractionDigits: 2 }
        ).format(Math.floor(this.pointsToNextTier / 5));
        this.spendTillNextTier = formattedSpend.replace(/(\.\d*?[1-9])0+$|\.0+$/, '$1');
      }
    })
  }

  get pointsToNextTier () {
    return this.state.pointsToNextTier
  }

  get spendTillNextTier () {
    return this.state.spendTillNextTier
  }

  set pointsToNextTier (value) {
    const dataToNextTierInjectEls = document.querySelectorAll('[data-points-to-next-tier-inject]')
    const dataPointsUntilNextTierTextEls = document.querySelectorAll('[data-points-until-next-tier-text]')

    if (!dataToNextTierInjectEls.length && !dataPointsUntilNextTierTextEls.length) return
    
    dataPointsUntilNextTierTextEls.forEach(el => {
      el.textContent = value
    })
    dataToNextTierInjectEls.forEach(el => {
      el.setAttribute('aria-busy', 'false')
    })

    this.state.pointsToNextTier = value
  }

  set spendTillNextTier (value) {
    const nextTierSpendTextEl = document.querySelector('[data-next-tier-spend-text]')

    if (!nextTierSpendTextEl) return

    nextTierSpendTextEl.textContent = value

    this.state.spendTillNextTier = value
  }
}

customElements.define('extract-sdk-ll-data', ExtractSDKLLData)
